import { render, staticRenderFns } from "./CustomerMeetings.vue?vue&type=template&id=4a5515d2&scoped=true"
import script from "./CustomerMeetings.vue?vue&type=script&lang=ts"
export * from "./CustomerMeetings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5515d2",
  null
  
)

export default component.exports